import React from 'react';
import { SOCIAL_LINKS } from '../../data/socialLinks';

const PATHS = {
  instagram: (
    <>
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </>
  ),
  linkedin: (
    <>
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
      <rect x="2" y="9" width="4" height="12" />
      <circle cx="4" cy="4" r="2" />
    </>
  ),
  facebook: <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />,
  youtube: (
    <>
      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" />
      <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" />
    </>
  ),
  x: <path d="M4 4l7.5 10L4 20h2l6.3-5.4L17 20h3l-7.8-10.4L19.5 4h-2l-5.8 5L8 4H4z" fill="currentColor" stroke="none" />,
};

export const SocialIcon = ({ id, className = 'h-4 w-4' }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    {PATHS[id]}
  </svg>
);

// Row of round icon links to Poonam's channels. `tone` picks colours for a dark or a light background; `showLabels` adds the
// platform name beside each icon (the footer).
const SocialLinks = ({ tone = 'dark', showLabels = false, className = '' }) => {
  if (!SOCIAL_LINKS.length) return null;
  const toneClass = tone === 'dark'
    ? 'border-canvas/30 text-canvas/85 hover:border-amber hover:text-amber'
    : 'border-brand-dark/25 text-brand-dark/75 hover:border-brand-accent hover:text-brand-accent';

  return (
    <ul className={`flex flex-wrap items-center gap-2 ${className}`}>
      {SOCIAL_LINKS.map((item) => (
        <li key={item.id}>
          <a
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Poonam on ${item.label}`}
            title={item.label}
            className={`inline-flex items-center justify-center gap-2 border transition duration-300 hover:-translate-y-0.5 ${toneClass} ${showLabels ? 'px-3.5 py-2' : 'h-8 w-8 rounded-full'}`}
          >
            <SocialIcon id={item.id} />
            {showLabels && <span className="text-[11px] font-semibold uppercase tracking-[0.16em]">{item.label}</span>}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default SocialLinks;
